import { ReferenceMapped } from "./ReferenceMapped.js";
/**
 * @internal scope: workspace
 */
export function normalizeReferenceMappedArgs(params) {
    if (params.length === 1) {
        const [options] = params;
        return options;
    }
    const [origin, transform] = params;
    return { origin, transform };
}
/**
 * @internal scope: workspace
 */
export function isReferenceMappedCurryParams(params) {
    return params.length === 1 && typeof params[0] === "function";
}
export function mapRef(...params) {
    if (isReferenceMappedCurryParams(params)) {
        return (origin) => {
            const [transform] = params;
            return new ReferenceMapped({ origin, transform });
        };
    }
    return new ReferenceMapped(normalizeReferenceMappedArgs(params));
}
